import * as types from '../mutation-types';
import accounts from '../../api/accounts';

const state = {
  providers: []
};

const getters = {
  Providers: state => state.providers
};

const actions = {
  async getProviderList({ commit, state }) {
    if (state.providers.length === 0) {
      const response = await accounts.getAccountsList(
        1,
        500,
        [{ 'name.raw': 'asc' }],
        '*',
        { 'nested.businesses.type.name': ['provider'] },
        null,
        ['name', 'businesses.id', 'businesses.type.name']
      );
      commit(types.SET_PROVIDERS, response);
    }
  }
};

const mutations = {
  [types.SET_PROVIDERS](state, response) {
    state.providers = response.hits.map(hit => ({
      id: hit._source.businesses.find(business => business.type.name === 'provider').id,
      name: hit._source.name
    }));
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
